function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.3 50l40-40 9.9 9.9L30.1 50l30.1 30.1-9.9 9.9-40-40zm69.5 40l9.9-9.9L59.6 50l30.1-30.1-9.9-9.9-40 40 40 40z"
});

function SvgDoubleArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 125"
  }, props), _ref);
}

export default SvgDoubleArrowLeft;